import { z } from 'zod';
export const uuidSchema = z.string().uuid();
/** Version sémantique Ghost, sans préfixe « v ». */
export const semVerSchema = z
    .string()
    .regex(/^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/, 'Version sémantique attendue (ex. 5.87.1)');
export const httpUrlSchema = z
    .string()
    .url()
    .refine((value) => /^https?:\/\//.test(value), 'URL http(s) attendue');
/**
 * Expression cron à 5 champs. La validation fine (bornes par champ) est déléguée au
 * planificateur ; on écarte ici les saisies manifestement invalides.
 */
export const cronSchema = z
    .string()
    .trim()
    .regex(/^(\S+\s+){4}\S+$/, 'Expression cron à 5 champs attendue (minute heure jour mois jour-semaine)');
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=common.js.map